<!-- ID FIELD -->
<div class="flex flex-col gap-2 mb-7">
  <ngx-skeleton-loader class="flex" [theme]="{ width: '40px', height: '13px' }"/>
  <ngx-skeleton-loader class="flex" [theme]="{ width: '150px', height: '19px' }"/>
</div>
<!-- TABS -->
<div class="flex gap-4 justify-center items-center border-b-2 border-gray-100 h-9 mb-4">
  <ngx-skeleton-loader class="flex" [theme]="{ width: '43px', height: '18px' }"/>
  <ngx-skeleton-loader class="flex" [theme]="{ width: '102px', height: '18px' }"/>
  <ngx-skeleton-loader class="flex" [theme]="{ width: '36px', height: '18px' }"/>
</div>
<!-- DATES FIELD AREA -->
<ngx-skeleton-loader class="flex w-full h-20 mb-4" [theme]="{ width: '100%', height: '100%', borderRadius: '8px' }"/>
<!-- CAROUSEL -->
<div class="flex gap-2 px-4 h-36 mb-4">
  <ngx-skeleton-loader class="flex h-full w-3/4" [theme]="{ width: '100%', height: '100%', borderRadius: '10px' }"/>
  <ngx-skeleton-loader class="flex h-full w-1/4" [theme]="{ width: '100%', height: '100%', borderRadius: '10px 0 0 10px' }"/>
</div>
<!-- FORM FIELDS -->
<div class="flex flex-col gap-3 mb-4">
  <div class="flex flex-col gap-2">
    <ngx-skeleton-loader class="flex" [theme]="{ width: '52px', height: '13px' }"/>
    <div class="flex items-center gap-2">
      <ngx-skeleton-loader class="flex" appearance="circle" [theme]="{ width: '24px', height: '24px' }"/>
      <ngx-skeleton-loader class="flex" [theme]="{ width: '180px', height: '19px' }"/>
    </div>
  </div>
  <div class="flex flex-col gap-2">
    <ngx-skeleton-loader class="flex" [theme]="{ width: '25px', height: '13px' }"/>
    <ngx-skeleton-loader class="flex" [theme]="{ width: '65px', height: '19px' }"/>
  </div>
  <div class="flex flex-col gap-2">
    <ngx-skeleton-loader class="flex" [theme]="{ width: '25px', height: '13px' }"/>
    <ngx-skeleton-loader class="flex" [theme]="{ width: '150px', height: '19px' }"/>
  </div>
  <div class="flex flex-col gap-2">
    <ngx-skeleton-loader class="flex" [theme]="{ width: '66px', height: '13px' }"/>
    <ngx-skeleton-loader class="flex" [theme]="{ width: '140px', height: '19px' }"/>
  </div>
  <div class="flex flex-col gap-2">
    <ngx-skeleton-loader class="flex" [theme]="{ width: '28px', height: '13px' }"/>
    <ngx-skeleton-loader class="flex" [theme]="{ width: '210px', height: '19px' }"/>
  </div>
  <div class="flex flex-col gap-2">
    <ngx-skeleton-loader class="flex" [theme]="{ width: '80px', height: '13px' }"/>
    <ngx-skeleton-loader class="flex py-2" [theme]="{ width: '5px', height: '3px' }"/>
  </div>
  <div class="flex flex-col gap-2">
    <ngx-skeleton-loader class="flex" [theme]="{ width: '42px', height: '13px' }"/>
    <ngx-skeleton-loader class="flex py-2" [theme]="{ width: '5px', height: '3px' }"/>
  </div>
  <div class="flex flex-col gap-2">
    <ngx-skeleton-loader class="flex" [theme]="{ width: '56px', height: '13px' }"/>
    <ngx-skeleton-loader class="flex py-2" [theme]="{ width: '5px', height: '3px' }"/>
  </div>
  <div class="flex flex-col gap-2">
    <ngx-skeleton-loader class="flex" [theme]="{ width: '42px', height: '13px' }"/>
    <ngx-skeleton-loader class="flex" [theme]="{ width: '90px', height: '23px', borderRadius: '8px' }"/>
  </div>
  <div class="flex flex-col gap-2">
    <ngx-skeleton-loader class="flex" [theme]="{ width: '64px', height: '13px' }"/>
    <ngx-skeleton-loader class="flex" [theme]="{ width: '100px', height: '19px' }"/>
  </div>
</div>